//  Login GraphQL Query Start
export const LOGIN_USER = `
query getOAuthTokenForVendor ($userName : String! $password : String! $otpLogIn: Boolean!){
    getOAuthTokenForVendor(
      loginCredential: { userName: $userName, password: $password }
      otpLogIn: $otpLogIn
    ) {
      token
      expiresIn
      refreshExpiresIn
      refreshToken
      tokenType
      loginDevicesResponses {
        deviceId
        deviceName
      }
      maxSessionStatus
      userBasicDetail {
        id
        arangoId
        name
        phone {
          countryCode
          dialNumber
        }
        locationDetail {
          state
          district
          tehsil
          village
          pinCode
          latitude
          longitude
        }
        interests {
          id
          fullName
        }
        imageUrl {
          id
          url
          fileType
        }
        hasShippingAddress
        hasMetaDataCollection
        gender
        isExpert
        referenceCode
        address
        email
        numberOfFamilyMembers
        highestQualification {
          id
          value
        }
        occupation {
          id
          value
        }
        occupationDetails
        detailCompletionPercentage
        expertBadge {
          id
          value
          badgeImageUrl {
            id
            url
            fileType
          }
        }
        defaultShippingAddressPinCode
        registrationDate
        appRating {
          rating
          feedback
          ratingGivenAt
        }
        deviceToken
        userType
        isExpertFormSubmitted
        userKnowsLanguages
        createdDate
        detailModifiedAfterDemotion
      }
    }
  }`;
//  Login GraphQL Query End

//DashBoard All API Start

export const DASHBOARD_ITEM_SOLD = `{
  getItemSold
}`;

export const GET_DASH_EARNING = `{
  getEarning
}`;

export const GET_DASH_TOTAL_PRODUCTS = `{
  getTotalProduct
}`;

export const GET_DASH_NEW_ORDER = `{
  getNewOrder
}`;

export const ORDER_STATISTICS = `query getOrderStatistics($orderStage: OrderStage){
  getOrderStatistics(orderStage: $orderStage)
}`;

export const GET_PAST_TRENDS = `query pastTrends($topSellingProduct: TopSellingProduct) {
  pastTrends(topSellingProduct: $topSellingProduct)
}`;

export const GET_TOP_SELLING_PRODUCTS = `
query topSellingProducts($fromDate: String, $toDate: String, $inventoryId: String, $paginationFilter: PaginationFilter!) {
  topSellingProducts(
    topSellingProduct: {
      paginationFilter: $paginationFilter
      inventoryId: $inventoryId
      fromDate: $fromDate
      toDate: $toDate
    }
  ) {
    count
    list {
      sku
      productName
      brandName
      type
      stock
      revenue
      variant
      totalSale
      imageUrl
      totalQuantitySold
    }
    pageInfo {
      offset
      hasNext
      hasPrevious
      totalCounts
      limit
      pageNumber
      order
    }
  }
}
`;

export const GET_SHOP_BY_CATEGORY = `
query getSalesByCategory($fromDate: String,$toDate:String) {
  getSalesByCategory(
  fromDate: $fromDate
  toDate: $toDate
  )
}
`;

export const GET_REVIEW_REPORT_DATA = `
query getReviewReportData($paginationFilter : PaginationFilter!){
  getReviewReportData(paginationFilter: $paginationFilter) {
   list {
      userMobile
      name
      productName
      productImageUrl
      title
      message
      reviewStar
      lastUpdatedDate
      imageUrl
      videoUrl
    }
    pageInfo {
      offset
      hasNext
      hasPrevious
      totalCounts
      limit
      pageNumber
      order
    }
  }
}`;

export const GET_REVENUE = `
query getRevenue($categories: [String] $dateFilter : DateFilter){
  getRevenue(categories: $categories, dateFilter :$dateFilter)
}
`;

export const CUSTOMERS_RATING = `{
  getCustomersRating {
    averageRating
    totalReview
    ratings {
      star
      percent
      userCount
    }
  }
}
`;

export const GET_RECENT_ORDERS = `
query getRecentOrders($paginationFilter : PaginationFilter!){
  getRecentOrders(paginationFilter: $paginationFilter) {
    count
    list {
      orderRefId
      orderKey
      grossSale
      customerName
      paymentMethod
      purchasedDate
      pickupLocation
      deliveryWay
      orderStatus
      isPreBooked
      amountPaid
      isFullPayment
      orderStatuses
      lastUpdatedDate
      customerId
      earning
      shippingAddress {
        isUgst
        fullName
        contactNumber
        email
        address
        streetDetail
        landMark
        pinCode
        addressType
        country {
          id
          name
        }
        state {
          id
          name
        }
        district {
          id
          name
        }
        tehsil {
          id
          name
        }
        village {
          id
          name
        }
      }
      byRefId {
        orderStatus
        productName
        sellerName
        deliveryWay
        sku
      }
      refundStatus
      soldBy
      returnId
      returnByUserDate
      deliveryDate
      email
      phoneNumber
      storeEmail
      storePhoneNumber
      externalDeliveryMode
      storeName
      shippingPartner
    }
    pageInfo {
      offset
      hasNext
      hasPrevious
      totalCounts
      limit
      pageNumber
      order
    }
  }
}`;

//DashBoard All API End

//Seller Domain All API Start
export const GET_SELLER_PRODUCT_CATEGORIES = `{
  getSellerProductCategories {
    id
    key
    name
  }
}`;
//Seller Domain All API End

// My Profile Start
export const UPDATE_PORTAL_USER = `
mutation updatePortalUser($payload:UpdatePortalUserPayload!, $profilePicture: Upload){
  updatePortalUser(
    payload:$payload
    profilePicture:$profilePicture
  )
}`;

export const UPDATE_PORTAL_USER_PASSWORD = ` 
mutation changeMyPassword($myPasswordInput:ChangeMyPasswordInput!){
  changeMyPassword(
    myPasswordInput: $myPasswordInput
  )
}
`;
export const LOGIN_BY_PHONE = `
query getOtpForVendorLogin($userName: String!){
  getOtpForVendorLogin(userName: $userName)
}`;

export const GET_LANGUAGES = `
query getLanguages($filterInput: FilterInput) {
  getLanguages(filterInput: $filterInput) {
    id
    langName
    code
    googleCode
  }
}`;

export const GET_VENDOR_BY_ID = `
query getUserById($id: String!){
  getUserById(id: $id) {
    id
    arangoId
    userName
    name
    phone {
      countryCode
      dialNumber
    }
    imageUrl {
      id
      url
      fileType
    }
    email
    userType
    userKnowsLanguages
  }
}`;

// My Profile END

//Reports & Analytics Start
export const REPORTS_ANALYTICS_ORDER = `
  query getOrderCounters($orderRequestFilters: OrderRequestFilters!) {
    getOrderCounters(orderRequestFilters: $orderRequestFilters)
  }
`;

export const GET_REPORTS_ANALYTICS_STOCK_INFO = `
query getStockInfo($inventoryReportPagination: InventoryReportPagination) {
  getStockInfo(inventoryReportPagination: $inventoryReportPagination)
}
`;

export const GET_REPORTS_ANALYTICS_PRODUCTS = `
query getAllProducts($inventoryReportPagination: InventoryReportPagination) {
  getAllProducts(inventoryReportPagination: $inventoryReportPagination)
}
`;

//Reports & Analytics End

// VENDOR_STORES START
export const VENDOR_STORES = `
{
  getInventoryIds {
    storeKey
    storeId
    storeName
  }
}`;

// VENDOR_STORES END

//INVENTORY COMPONENT START
export const GET_INVENTORY_LISTING = `
query getInventoryListing($inventoryListingFilters: InventoryListingFilters) {
  getInventoryListing(inventoryListingFilters: $inventoryListingFilters) {
    count
    list {
      productId
      productType
      productCategory
      variantInfo {
        productImage
        productName {
          name
          sku
        }
          margin
          hsnCode 
        variantStatus
        stock
        mrp
        sellingPrice
        settlementValue
        sale
        publishedOn
        status
        variantId
        afterSalePrice
        variantName
        maxSellingLimit
        expirationDate
        saleStartDate
        saleEndDate
        saleDiscount
        returnStatus
        isPreBookAble
        preBookAmount
        lastDateForPreBook
        estimatedDeliveryDate
      }
    }
    pageInfo {
      offset
      hasNext
      hasPrevious
      totalCounts
      limit
      pageNumber
      order
    }
  }
}`;

export const UPDATE_STOCK_STATUS = `
mutation updateStockStatus($productVariantInventory: ProductVariantInventory) {
  updateStockStatus(productVariantInventory: $productVariantInventory)
}`;

export const DELETE_STOCK = `
mutation deleteStock($productVariantInventory: ProductVariantInventory) {
  deleteStock(productVariantInventory: $productVariantInventory)
}`;

export const UPDATE_SALE = `
mutation updateSale ($vendorProductVariantSale : VendorProductVariantSale){
  updateSale(vendorProductVariantSale: $vendorProductVariantSale)
}`;

export const SALE_LIST = ` 
query getStockEntities($inventoryProductId : InventoryProductId){
  getStockEntities(inventoryProductId: $inventoryProductId) {
    variantSize
    sku
    variantKey
    productKey
    inventoryKey
    returnStatus
    cashOnDeliveryStatus
    startDateForPreBook
    estimatedDeliveryEndDate
    saleStartDate
    saleEndDate
    mrp
    batchNumber
    hsnCode
    price
    stock
    lotExpirationDate
    sellingLimit
    discount
    salePrice
    saleDiscountPercentage
    isPreBookAble
    isCancellable
    preBookAmount
    lastDateForPreBook
    estimatedDeliveryDate
    cancellationDate
    lastDateForFullPayment
    autoCancelAble
    minimumOrderQuantity
  }
}`;

export const REMOVE_SALE = `
mutation removeSale($inventoryProductId: InventoryProductId) {
  removeSale(inventoryProductId: $inventoryProductId)
}`;

export const UPDATE_INVENTORY_STOCK = `
mutation updateStock($stockPostRequest: StockPostRequest!) {
  updateStock(stockPostRequest: $stockPostRequest)
}
`;
export const GET_DOSAGE = `
query getDosage ($animalDosageRequest: AnimalDosageRequest){
  getDosage(animalDosageRequest:$animalDosageRequest) {
    tagId
    dosage
  }
}`;

export const GET_TARGET_CROP_CONCERN_AND_DOSAGES = `
query getTargetCropConcernAndDosages($cropId: String , $productId:String){
  getTargetCropConcernAndDosages(cropId:$cropId , productId:$productId ) {
    dosages {
      lifecycleStage
      stageDosages {
        lifecycleSubStage
        applicationTime
        applicationMethod
        age
        dose {
          min
          max
          unit
        }
        solvent {
          name
          min
          max
          unit
        }
        sefinar {
          min
          max
          unit
        }
        sticker {
          min
          max
          unit
        }
        surfactant {
          name
          min
          max
          unit
        }
        seedTreatments {
          name
          min
          max
          unit
        }
        area {
          area
          unit
        }
      }
    }
    concerns
  }
}`;
//INVENTORY COMPONENT END

//Brands Start
export const GET_BRANDS = `{
  getBrandsBySeller {
    id
    key
    name
  }
}`;

export const GET_ALL_BRANDS = `query {
  getCompanies(text: "") {
    id
    key
    name
  }
}`;
//Brands End

//Product Start
export const PRODUCT_LISTING = `query getProductsListing($filters: ProductListingFilters!) {
  getProductsListing(productListingFilters: $filters) {
    count
    list {
      productId
      image
      name
      brand
      brandId
      domain
      domainId
      productCategory
      productCategoryId
      productBase
    }
    pageInfo {
      offset
      hasNext
      hasPrevious
      totalCounts
      limit
      pageNumber
      order
    }
  }
}`;

export const GET_PRODUCT_DETAIL = `query getProductDetailedInfo($productId: String!, $productBase: ProductBase!) {
  getProductDetailedInfo(productId: $productId, productBase: $productBase) {
    productDetailedResponse {
      name
      images {
        image
        featured
      }
      videos
      productDetails {
        brand {
          name
          image
        }
        productDomain
        productParentCategory
        composition {
          macro {
            percentage
            chemical
            formulation
          }
          micro {
            percentage
            chemical
            formulation
          }
          technicalName
        }
        productType
        taxSlab
        physicalForm
        concerns
        storage
        instructions
        precautions
      }
      about {
        interests
        aboutItem
        apniKhetiProductReview {
          text
          videoUrl
        }
        howToUse {
          text
          videoUrl
          videoUrls
        }
      }
      variants {
        variantId
        image
        variant
        variantType
        modelNumber
        color
        dimension {
          length {
            quantity
            unit
          }
          width {
            quantity
            unit
          }
          height {
            quantity
            unit
          }
          weight {
            quantity
            unit
          }
        }
        taxSlab
        price
      }
      targetCrops {
        annual {
          id
          key
          name
        }
        perennial {
          id
          key
          name
        }
      }
    }
    seedDetailedInformationResponse {
      name
      images {
        image
        featured
      }
      videos
      productDetails {
        brand {
          name
          image
        }
        productDomain
        productParentCategory
        productType
        crop
        duration
        speciality
        seedType
        fruitWeight {
          min
          max
          unit
        }
        cropHeight {
          min
          max
          unit
        }
        averageYield {
          min
          max
          unit
        }
        maturity {
          min
          max
          unit
        }
        seedRate {
          min
          max
          unit
        }
        landArea {
          area
          unit
        }
        sowingTime {
          startTime
          endTime
        }
        seedClass
        cropSeasons
        sowingMethods
        states
        soils
        seedTreatments {
          chemical
          chemicalQuantity
          chemicalQuantityUnit
          seedQuantity
          seedQuantityUnit
        }
        storage
        instructions
        precautions
      }
      about {
        interests
        aboutItem
        apniKhetiProductReview {
          text
          videoUrl
        }
        howToUse {
          text
          videoUrl
          videoUrls
        }
      }
      variants {
        variantId
        image
        variant
        variantType
        modelNumber
        color
        dimension {
          length {
            quantity
            unit
          }
          width {
            quantity
            unit
          }
          height {
            quantity
            unit
          }
          weight {
            quantity
            unit
          }
        }
        taxSlab
        price
      }
    }
    feedSupplementDetailedResponse {
      name
      images {
        image
        featured
      }
      videos
      productDetails {
        brand {
          name
          image
        }
        productDomain
        productParentCategory
        composition {
          composition {
            percentage
            chemical
            formulation
          }
          activeIngredients {
            percentage
            chemical
            formulation
          }
        }
        productType
        physicalForm
        concerns
        storage
        instructions
        precautions
        dateOfManufacturing
        expiryDate
      }
      about {
        interests
        aboutItem
        apniKhetiProductReview {
          text
          videoUrl
        }
        howToUse {
          text
          videoUrl
          videoUrls
        }
      }
      variants {
        variantId
        image
        variant
        variantType
        modelNumber
        color
        dimension {
          length {
            quantity
            unit
          }
          width {
            quantity
            unit
          }
          height {
            quantity
            unit
          }
          weight {
            quantity
            unit
          }
        }
        taxSlab
        price
      }
      targetAnimals {
        id
        key
        name
      }
    }
    machineryDetailedResponse {
      name
      images {
        image
        featured
      }
      videos
      productDetails {
        brand {
          name
          image
        }
        productDomain
        productParentCategory
        productType
        machineryType
        concerns
        farmingOperations
        storage
        instructions
        precautions
        dateOfManufacturing
      }
      about {
        interests
        aboutItem
        apniKhetiProductReview {
          text
          videoUrl
        }
        howToUse {
          text
          videoUrl
          videoUrls
        }
      }
      variants {
        variantId
        image
        variant
        variantType
        modelNumber
        color
        dimension {
          length {
            quantity
            unit
          }
          width {
            quantity
            unit
          }
          height {
            quantity
            unit
          }
          weight {
            quantity
            unit
          }
        }
        taxSlab
        price
      }
    }
  }
}`;

export const VARIANT_WITHOUT_INVENTORY = `query getProductVariantsNotAddedToInventory(
  $inventoryId: String
  $productId: String
) {
  getProductVariantsNotAddedToInventory(
    inventoryId: $inventoryId
    productId: $productId
  ) {
    sku
    variantId
    image
    variant
    variantType
    modelNumber
    color
    dimension {
      length {
        quantity
        unit
      }
      width {
        quantity
        unit
      }
      height {
        quantity
        unit
      }
      weight {
        quantity
        unit
      }
    }
    taxSlab
    price
  }
}`;

export const SAVE_STOCK = `mutation saveStock($payload: StockPostRequest){
  saveStock(
    stockPostRequest: $payload
  )
}`;

export const SAVE_PRODUCT = `mutation saveVendorProduct($payload: ProductSaveRequest){
  saveVendorProduct(productSaveRequest: $payload) {
    productId
    requestId
    name
    brandName
    description
    status
    createdDate
    lastModifiedDate
    createdI
    lastModifiedIp
  }
}`;

export const GET_APPROVAL_REQUESTS = `query getApprovalRequest($payload: TrackApprovalRequestFilters!) {
  getApprovalRequest(approvalRequestFilters: $payload) {
    count
    list {
      productId
      requestId
      imageLink
      productDetails
      seller
      status
      comments
      createdDate
    }
    pageInfo {
      offset
      hasNext
      hasPrevious
      totalCounts
      limit
      pageNumber
      order
    }
  }
}`;

export const GET_VENDOR_PRODUCT_DETAILS = `query ($productId: String!){
  getVendorProductDetail(productId: $productId) {
    productId
    sellerId
    sellerName
    createdDate
    name
    productDetails
    description
    imageLinks
    status
    comments
  }
}`;
//Product End

// Categories Start

export const GET_ALL_PRODUCT_CATEGORIES = `query {
  getAllProductDomains {
    id
    name
    isMandatoryToSelectSubCategories
    isMandatoryToUploadLicense
  }
}`;

export const GET_PARENT_BY_DOMAIN = `query getParentCategoriesByRootId($id: String!){
  getParentCategoriesByRootId(id: $id) {
    id
    key
    name
  }
}`;
// Categories End

// Store Settings Start
export const GET_INVENTORY_DETAILS = `query getInventory($inventoryId: String!) {
  getInventory(inventoryId: $inventoryId) {
    id
    storeName
    storeEmail
    storePhoneInput {
      countryCode
      storePhone
    }
    location {
      storePasscode
      storeAddressLine1
      storeAddressLine2
      city {
        key
        name
      }
      state {
        key
        name
      }
      landMark
      Description
    }
    imageUrl
    longLattCordinates {
      status
      longitude
      Latitude
    }
    createdDate
    updatedDate
    status
    inStorePickup
    gstAddress
    gstResponse {
      number
      doc {
        id
        fileKey
        fileType
      }
      status
    }
    panResponse {
      number
      doc {
        id
        fileKey
        fileType
      }
      status
    }
    licenseResponses {
      categoryId
      name
      supplierId
      supplierName
      licenseId
      licenseNumber
      expiryDate
      file {
        id
        fileKey
        fileType
      }
      status
    }
    digitalSignatureUrl
  }
}`;

export const RETURN_POLICY = `query getReturnPolicy($inventoryId: String!){
  getReturnPolicy(inventoryId: $inventoryId) {
    id
    returnEligibleDays
    returnEligiblePolicy
    exchangeEligibleDays
    exchangeEligiblePolicy
    createdDate
    updatedDate
    status
  }
}`;

export const CANCELLATION_POLICY = `query getCancellationPolicy($inventoryId: String!){
  getCancellationPolicy(inventoryId: $inventoryId) {
    id
    cancellationEligibleDays
    cancellationEligiblePolicy
    createdDate
    updatedDate
    status
  }
}`;

export const GET_SUPPLIERS = `query getAllSuppliers($productDomain : String!){
  getAllSuppliers(productDomain: $productDomain) {
    id
    name
    isLicenseMandatory
    isMultiLicenseUpload
  }
}`;

export const UPDATE_RETURN_POLICY = `mutation updateReturnPolicy($payload: ReturnPolicyPostRequest){
  updateReturnPolicy(
    returnPolicyPostRequest: $payload
  )
}`;

export const SAVE_RETURN_POLICY = `mutation ($payload: ReturnPolicyPostRequest) {
  saveReturnPolicy(returnPolicyPostRequest: $payload)
}`;

export const UPDATE_CANCELLATION_POLICY = `mutation updateCancellationPolicy($payload: CancellationPostRequest) {
  updateCancellationPolicy(cancellationPostRequest: $payload)
}`;

export const SAVE_CANCELLATION_POLICY = `mutation ($payload: CancellationPostRequest){
  saveCancellationPolicy(
    cancellationPostRequest: $payload
  )
}`;

export const UPDATE_INVENTORY = `mutation updateInventory($payload: InventoryPutRequest) {
  updateInventory(inventoryPutRequest: $payload)
}`;

export const ADD_INVENTORY = `mutation addInventory($payload: InventoryPostRequest) {
  addInventory(inventoryPostRequest: $payload)
}`;
// Store Settings End

//ALL LOCATIONS START
export const GET_PARENT_LOCATION = `
query getLocationByName($startsWith: String!, $locationType: LocationType, $status: Status!) {
  getLocationByName(
    startsWith: $startsWith
    locationType: $locationType
    status: $status
  ) {
    id
    name
    createdIp
    createdDate
    lastModifiedIp
    lastModifiedDate
    status
    latitude
    longitude
    dialCode
    unCode
    unionTerritory
    utGstApplicable
    nickNames
    pinCode
  }
}
`;

export const GET_CHILD_LOCATIONS = `
query getAllChildrenLocationsWithParentId($filterInput: FilterInput, $parentIds: [String]) {
  getAllChildrenLocationsWithParentId(filterInput: $filterInput, parentIds: $parentIds)
}
`;
//ALL LOCATIONS END

export const RETURN_LISTING = `
query getCategorizedReturnOrders($orderRequestFilters : OrderRequestFilters) {
  getCategorizedReturnOrders(orderRequestFilters: $orderRequestFilters) {
    count
    list {
      orderRefId
      customerName
      customerId
      customerKey
      createdDate
      email
      phoneNumber
      storeEmail
      vendorPhoneNumber
      vendorName
      storeId
      storeKey
      paymentMethod
      returnId
      returnedRequestedDate
      deliveryDate
      returnApproveDate
      returnCancelledDate
      refundValue
      refundStatus
      billingAddress {
        isUgst
        fullName
        contactNumber
        email
        address
        streetDetail
        landMark
        pinCode
        addressType
        country {
          id
          name
        }
        state {
          id
          name
        }
        district {
          id
          name
        }
        tehsil {
          id
          name
        }
        village {
          id
          name
        }
      }
    }
    pageInfo {
      offset
      hasNext
      hasPrevious
      totalCounts
      limit
      pageNumber
      order
    }
  }
}
`;

export const RETURN_BY_REF = `
query getReturnByRef($orderRefId : String) {
  getReturnByRef(orderRefId: $orderRefId) {
     orderRefId
    paymentMethod
    sellingAmount
    lastUpdatedDate
    orderStatus
    trackingId
    refundStatus
    vendorApprovedRefund
    refundReason
    refundApproveDate
    refundCancelledDate
    refundInitiatedDate
    refundCompletedDate
    generalInformation {
      returnId
      returnRequestDate
      orderedDate
      deliveredDate
      customerName
      customerEmail
      customerPhoneNumber
    }
    originalShipmentMode {
      shipmentMode
      trackingID
    }
    returnProductRequest {
      proudctName
      variant
      sku
      imageUrl
      deliveryOption
      mrp
      sellingPrice
      quantity
      itemTotal
      returnReason
      returnAttachement
    }
    shippingAddress {
      isUgst
      id
      fullName
      contactNumber
      email
      address
      streetDetail
      landMark
      country {
        id
        name
      }
      state {
        id
        name
      }
      district {
        id
        name
      }
      tehsil {
        id
        name
      }
      village {
        id
        name
      }
      pinCode
      addressType
      isDefaultAddress
      latitude
      longitude
      isValidPinCode
      lastModifiedDate
    }
    storeAddress {
      fullName
      contactNumber
      email
      address
      landMark
      pinCode
      addressType
      state
      district
      storeOpenDays
  
    }
  }
}
`;

export const ORDER_STATUS_BAR = `
query getOrderStatusBar($orderRefId : String) {
  getOrderStatusBar(orderRefId: $orderRefId)
}
`;

export const GET_RETURN_SHIPMENT = `
 query getReturnShipment($orderRefId : String){
  getReturnShipment(orderRefId: $orderRefId ) {
    externalDeliveryMode
    width
    height
    breadth
    weight
    sku
    productName
    variantName
    imageUrl
    deliveryOption
    shipmentType
    originalShipmentProvide
    shipmentMode
    dateShipped
    trackingId
    shipmentStatus
    orderStatusStream
    deliveryMode
    orderStatus
  }
}
`;

export const CHANGE_STATUS_OF_ORDER = `
mutation changeStatusOfOrder($orderStatusChangeRequest : OrderStatusChangeRequest) {
  changeStatusOfOrder(orderStatusChangeRequest: $orderStatusChangeRequest)
}
`;

export const ACCEPT_RETURN = `
mutation acceptReturn($approveOrderRequest : ApproveOrderRequest) {
  acceptReturn(approveOrderRequest: $approveOrderRequest)
}
`;

export const ORDER_LISTING = `
query getCategorizedOrders($orderRequestFilters : OrderRequestFilters!) {
  getCategorizedOrders(orderRequestFilters: $orderRequestFilters) {
    count
    list {
      orderRefId
      orderKey
      grossSale
      customerName
      paymentMethod
      purchasedDate
      pickupLocation
      deliveryWay
      orderStatus
      isPreBooked
      amountPaid
      isFullPayment
      settlementValue
      orderStatuses
      lastUpdatedDate
      customerId
      earning
      shippingAddress {
        isUgst
        fullName
        contactNumber
        email
        address
        streetDetail
        landMark
        pinCode
        addressType
        country {
          id
          name
        }
        state {
          id
          name
        }
        district {
          id
          name
        }
        tehsil {
          id
          name
        }
        village {
          id
          name
        }
      }
      byRefId {
        orderStatus
        productName
        variant
        sellerName
        deliveryWay
        sku
        quantity
      }
      refundStatus
      soldBy
      returnId
      returnByUserDate
      deliveryDate
      email
      phoneNumber
      storeEmail
      storePhoneNumber
      externalDeliveryMode
      storeName
      shippingPartner
      settlementStatus
       shipRockedShipmentId
      courierPartnerShipmentId
      prozoAwbNumber
    }
    pageInfo {
      offset
      hasNext
      hasPrevious
      totalCounts
      limit
      pageNumber
      order
    }
  }
}
`;

export const GET_BY_REF_ID = `
query getByRefId($orderRefId : String) {
  getByRefId(orderRefId:$orderRefId) {
    orderItem {
      orderRefId
      isShipmentCancelled
      productName
      productImageURL
      sku
      cancelledReason
      shipmentCharge
      sellerName
      productDomainCategory
      cost
      quantity
      itemId
      reportUrl
      total
      earning
      deliveryOption
      orderStage
      productCategory
      storeLocation
      itemId
      reportUrl
    }
    returnData {
      orderRefId
      productName
      productImageURL
      sku
      cancelledReason
      shipmentCharge
      sellerName
      cost
      quantity
      total
      earning
      deliveryOption
      orderStage
    }
    orderStatus
    paymentMethod
    shippingAddress {
      isUgst
      fullName
      contactNumber
      email
      address
      streetDetail
      landMark
      pinCode
      addressType
      country {
        id
        name
      }
      state {
        id
        name
      }
      district {
        id
        name
      }
      tehsil {
        id
        name
      }
      village {
        id
        name
      }
    }
    billingAddress {
      isUgst
      fullName
      contactNumber
      email
      address
      streetDetail
      landMark
      pinCode
      addressType
      country {
        id
        name
      }
      state {
        id
        name
      }
      district {
        id
        name
      }
      tehsil {
        id
        name
      }
      village {
        id
        name
      }
    }
    purchasedDate
    lastUpdateDate
    transactionID
    shippingMethod
    customerName
    phoneNumber
    customerId
    storeLocation
    isPreBooked
    isFullPayment
    amountPaid
    totalBill
    shipmentChargeTotal
    discountTotal
    tax
    grandTotal
    pickFromCount
    homeDeliveryCount
    orderTrackUrl
    originalTrackUrl
    email
    orderId
    prepaidDiscount
    platformFees
  }
}

`;

export const GET_TRANSCATION_DATA = `

query getTransactionData($orderRefId : String) {
  getTransactionData(orderRefId: $orderRefId ) {
    orderId
    transactionId
    orderCreatedDate
    paymentMethod
    paidStatus
    parentTransaction
    transactionType
  }
}
`;

export const GET_PAYMENT_DATA = `
query getPaymentData($orderRefId : String){
  getPaymentData(orderRefId: $orderRefId) {
    paymentMethod
    amount
    billingAddress {
      isUgst
      fullName
      contactNumber
      email
      address
      streetDetail
      landMark
      pinCode
      addressType
      country {
        id
        name
      }
      state {
        id
        name
      }
      district {
        id
        name
      }
      tehsil {
        id
        name
      }
      village {
        id
        name
      }
    }
    gateway
    gatewayAccount
  }
}
`;

export const SAVE_ORDER_REMARK = `
mutation saveOrderRemarks($id : String! $remarks : String!){
  saveOrderRemarks(request: { id: $id, remarks: $remarks })
}
`;

export const GET_ORDER_REMARK_HISTORY = `
query getOrderRemarksHistory($orderRefId : String $paginationFilter : PaginationFilter ) {
  getOrderRemarksHistory(orderRefId:$orderRefId , paginationFilter: $paginationFilter) {
    count
    list {
      remarks
      userName
      userId
      createdDate
      updatedDate
    }
    pageInfo {
      offset
      hasNext
      hasPrevious
      totalCounts
      limit
      pageNumber
      order
    }
  }
}
`;

export const GET_SHIPMENT_INSTORE = `
query getShippingDataInStore($orderRefId: String) {
  getShippingDataInStore(orderRefId: $orderRefId) {
    sellerDetail {
      sellerId
      name
      phoneNumber
      email
    }
     shippingInformation {
      productGroup {
        shipmentProvider
        productImage
        productName
        quantity
        dimension {
          length {
            quantity
            unit
          }
          width {
            quantity
            unit
          }
          height {
            quantity
            unit
          }
          weight {
            quantity
            unit
          }
        }
        deliveryOption
        productBasedId
        orderStatus
        sku
      }
      shipmentProvider
      externalDeliveryMode
      shipmentDate
      trackingNumber
      shipRockedShipmentId
      orderStatus
      deliveryMode
      courierPartnerShipmentId
    }
  }
}
`;

export const GET_SHIPMENT_DATA = `
query getShippingData($orderRefId : String) {
  getShippingData(orderRefId: $orderRefId) {
    sellerDetail {
      sellerId
      name
      phoneNumber
      email
    }
    shippingInformation {
      productGroup {
        shipmentProvider
        productImage
        productName
        quantity
        dimension {
          length {
            quantity
            unit
          }
          width {
            quantity
            unit
          }
          height {
            quantity
            unit
          }
          weight {
            quantity
            unit
          }
        }
        deliveryOption
        productBasedId
        orderStatus
        sku
      }
          shipmentProvider
      externalDeliveryMode
      shipmentDate
      trackingNumber
      shipRockedShipmentId
      orderStatus
      deliveryMode
      courierPartnerShipmentId
     
    }
  }
}
`;

export const CHANGE_STATUS_IN_STORE = `
mutation changeStatusOfInStoreOrder($orderStatusChangeRequest :OrderStatusChangeRequest ) {
  changeStatusOfInStoreOrder(orderStatusChangeRequest:$orderStatusChangeRequest)
}
`;

export const GET_SHIPMENT_HISTORY = `
 query shipmentHistory($orderRefID : String  , $id : String ) {
  shipmentHistory(orderRefID: $orderRefID, orderId: $id) {
    orderPackedDate
    createdDate
    awbCode
    status
    orderId
    orderRefID
    shipmentProvider
    shipmentStatus
    courierPartnerShipmentId
    acceptedDate
    shipmentDate
    cancelledDate
    completedDate
    cancelledData
    externalDeliveryMode
    deliveryMode
  }
}

`;

export const PRINT_INVOICE = `
query getInvoiceByRef($id :String! ) {
  getInvoiceByRef(orderRefId: $id)
}
`;

export const PRINT_LABEL = `
query getLabelByShipmentId($shipmentId : String  $shippingPartner: ShippingPartner){
  getLabelByShipmentId(shipmentId: $shipmentId, shippingPartner: $shippingPartner) {
    label_created
    label_url
    response
  }
}
`;

export const APPROVE_ORDERS = `
mutation approveOrdersByRefId($approveOrderRequest : ApproveOrderRequest) {
  approveOrdersByRefId(approveOrderRequest: $approveOrderRequest )
}
`;

export const CHANGE_PENDING_AMOUNT = `
mutation changePendingAmountForCOD($pendingAmountReceived : Boolean $orderRefID: String  ) {
  changePendingAmountForCOD(pendingAmountReceived:$pendingAmountReceived, orderRefID: $orderRefID)
}
`;

export const GET_WAYUVEGA_LIST = `
query  getApplicableShippingPartners($orderRefId : String  $shippingPartner: ShippingPartner){
  getApplicableShippingPartners(
    orderRefId: $orderRefId
    shippingPartner: $shippingPartner
  ) {
    serviceableServices
  }
}`;

export const GET_ORDER_REVENUE = `
query getRevenueWithOrders($orderRequestFilters : OrderRequestFilters!){
  getRevenueWithOrders(orderRequestFilters: $orderRequestFilters)
}
`;

export const GET_VENDOR_SETTLEMENTS = `
query getVendorSettlements($paginationFilter : PaginationFilter!){
  getVendorSettlements(paginationFilter: $paginationFilter) {
    list {
      id
      dateRange
      startDate
      endDate
      amount
      approvalStatus
      approvedDate
      paymentDate
      transactionId
      paymentStatus
      settlementDocument
    }
    pageInfo {
      offset
      hasNext
      hasPrevious
      totalCounts
      limit
      pageNumber
      order
    }
  }
}
`;

export const GET_SELLER_LISTING = `
query getSellerListing {
  getSellerListing {
    id
    arangoId
    name
  }
}
`;

export const GET_STORE_LISTING = ` query getStoresListing($vendorId : String!) {
  getStoresListing(vendorId:$vendorId) {
    id
    arangoId
    name
  }
}`;

export const GENERATE_MANIFEST = ` query exportManifest($orderId : [String!]! $storeId : String!  ){
  exportManifest(orderId: $orderId, storeId: $storeId)
}
`;


export const UPLOAD_BLOOD_SAMPLE_REPORT = `
mutation uploadSampleReport ($reportUploadRequest: ReportUploadRequest!) {
  uploadSampleReport (reportUploadRequest : $reportUploadRequest) } `;


export const GET_INVOICES_BY_REFS = ` 
  query getInvoicesByRefs ($orderRefIds : [String] ) {
    getInvoicesByRefs(orderRefIds: $orderRefIds)
  }
`;
